import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { authTokenCookie } from '../utils/CookieMaker';
import { getAPIMKey,getAccessDetails } from '../component/screens/customerComments/customerCommentsAction';
import { logout } from '../utils/utils';

// import { useAccessDetails } from '../common/AccessDetails/useAccessDetails';
// import { useFieldDetails } from '../common/AccessDetails/useFieldDetails';

import { LOGIN_ROOT } from '../service/apiUrls';

export const AccessDetailsProvider = ({ children }) => {
    const { authCookie } = authTokenCookie();
    // const { fetchAccessDetails, accessDetailsError,accessDetailsLoading, accessDetailsData } = useAccessDetails();
    // const { fetchFieldDetails, fieldDetailsError, fieldDetailsLoading, fieldDetailsData } = useFieldDetails();
    const { userInfo } = authTokenCookie();
    const [authenticated, setAuthenticated] = useState(false);
    const [alertTimer, setAlertTimer] = useState(false);
    const dispatch = useDispatch();
    useEffect(() => {
        let loc = window.location.href;
        if (authCookie.name !== null && !authenticated) {//sessionid check removed for validating ediection issue
            dispatch(getAPIMKey());      
                dispatch(getAccessDetails(userInfo))
                sessionStorage.setItem("sessionId", userInfo.userId)
            setAuthenticated(true);

        }
        else {
            //Clear browser session storage on logout.
            document.cookie.split(";").map(cookies => {
                document.cookie = cookies.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=" + loc);
                return cookies;
            });
            sessionStorage.clear();
            sessionStorage.setItem("sessionId", userInfo.userId)
            let url = LOGIN_ROOT.substring(0,LOGIN_ROOT.length)           

            window.location.replace(`${url}/authenticate`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // useEffect(() => {
    //     if (ctlData.key) {
    //         dispatch(getAccessDetails(userInfo))
    //     }
    // }, [ctlData.key, dispatch, userInfo])


    useEffect(() => {
        const timer = setInterval(() => {
            let currentDate = new Date();
            let currentTime = currentDate.getTime();
            let { decodedIdToken, userInfo, authCookie } = authTokenCookie();
            // JWT exp is in seconds
            let sessionId = sessionStorage.getItem('sessionId')
            if (authCookie && authCookie.name && sessionId === userInfo.userId) {
                let tokenExpiry = decodedIdToken.exp * 1000;
                if (currentTime + 300000 >= tokenExpiry && !alertTimer) {
                    //alert(`your session about to expire, please refresh the browser to retain the session`)
                    setAlertTimer(true);
                }
                else if (tokenExpiry <= currentTime) {
                    //  window.location.replace(`${LOGIN_ROOT}/refresh`);
                    logout();
                }
            }
            else if (authenticated && authCookie.name === null) {
                logout();
            }
        }, 1000);

        return () => clearInterval(timer);
    }, [authenticated, alertTimer]);

    // const checkAccess = useCallback(() => {
    //     return (
    //         !accessDetailsLoading && !fieldDetailsLoading && 
    //         !accessDetailsError && !fieldDetailsError && 
    //         accessDetailsData && fieldDetailsData
    //     );
    // },[accessDetailsData, accessDetailsLoading, accessDetailsError, fieldDetailsError, fieldDetailsLoading, fieldDetailsData]);

    // if(accessDetailsError || fieldDetailsError ){
    //     const errorDetails = accessDetailsError ? accessDetailsError : fieldDetailsError;
    //     return (
    //         <ServiceError programName={"ACCESS DETAILS"} error={errorDetails} />
    //     );
    // }

    if (authenticated) {
        return <>{children}</>
    }
    else {
        return null;
    }
};

export default AccessDetailsProvider;
